import { Container, Row, Col} from "react-bootstrap"
import ImageTelegram from "../Images/ImageTelegram.svg"
import ImageDotright from "../Images/ImageDotright.svg"
import ImageTelegramGoogle from "../Images/ImageQRTelegramGoogle.png"
import ImageTelegramApple from "../Images/ImageQRTelegramApple.png"



function Telegram() {
    const MyStyle =  {
        color: "black",
        fontSize: "3.5vmin"        
    }

    const MyStyle2 =  {
        color: "white",
        fontSize: "2.5vmin"        
    }


    return (        
        <Container fluid style={{backgroundColor: "#afc7c7"}}>
            <Row>
                <Col style={{margin: "3% 0% 0% 0%", textAlign: "right", padding: "0px"}}>
                    <img src={ImageTelegram} alt="MessageBox" className="img-fluid" style={{width: "5vmin"}}></img>                   
                </Col>
                <Col style={{margin: "3% 0% 0% 0%", textAlign: "left"}}>
                    <div style={MyStyle}>Telegram</div>                    
                </Col>
            </Row>    
            <Row style={{margin: "0% 3% 3% 3%"}}>                
                <Col style={{textAlign: "Left"}}>
                    <div style={MyStyle2}>
                        <br/>
                       Um die Nachrichten der MessageBox zu empfangen ist die Telegram-App auf Ihrem Smartphone erforderlich. <br/>
                       Bei der Telegram-App handelt es sich um eine Messenger-App, ähnlich wie WhatsApp. <br/>
                       Allerdings bietet Telegram eine Softwareschnittstelle um Anwendungen wie die der MessageBox erstellen zu können.<br/>
                       Warum verwenden wir Telegram:
                    </div>                                                                                               
                </Col>
            </Row>
            <Row style={{margin: "1% 0% 0% 0%"}}>                
                <Col xs={3} style={{textAlign: "right"}}>                    
                        <img src={ImageDotright} alt="MessageBox" className="img-fluid" style={{width: "3vmin"}}></img>                                       
                </Col>
                <Col style={{textAlign: "Left"}}>
                    <div style={MyStyle2}>                       
                       Telegram ist kostenlos
                    </div>                                                                                               
                </Col>                
            </Row>
            <Row style={{margin: "1% 0% 0% 0%"}}>                
                <Col xs={3} style={{textAlign: "right"}}>
                    <img src={ImageDotright} alt="MessageBox" className="img-fluid" style={{width: "3vmin"}}></img>                   
                </Col>
                <Col style={{textAlign: "Left"}}>
                    <div style={MyStyle2}>                       
                       weit verbreitet, viele nutzen bereits Telegram
                    </div>                                                                                               
                </Col>                
            </Row>
            <Row style={{margin: "1% 0% 0% 0%"}}>                
                <Col xs={3} style={{textAlign: "right"}}>
                    <img src={ImageDotright} alt="MessageBox" className="img-fluid" style={{width: "3vmin"}}></img>                   
                </Col>
                <Col style={{textAlign: "Left"}}>
                    <div style={MyStyle2}>                       
                       Telegram überliefert die Nachrichten verschlüsselt
                    </div>                                                                                               
                </Col>                
            </Row>
            <Row style={{margin: "1% 0% 0% 0%"}}>                
                <Col xs={3} style={{textAlign: "right"}}>
                    <img src={ImageDotright} alt="MessageBox" className="img-fluid" style={{width: "3vmin"}}></img>                   
                </Col>
                <Col style={{textAlign: "Left"}}>
                    <div style={MyStyle2}>                       
                       Telegram bietet eine Programmierschnittstelle
                    </div>                                                                                               
                </Col>                
            </Row>
            <Row style={{margin: "1% 0% 0% 0%"}}>                
                <Col xs={3} style={{textAlign: "right"}}>
                    <img src={ImageDotright} alt="MessageBox" className="img-fluid" style={{width: "3vmin"}}></img>                   
                </Col>
                <Col style={{textAlign: "Left"}}>
                    <div style={MyStyle2}>                       
                       keine Werbung
                    </div>                                                                                               
                </Col>                
            </Row>
            <Row style={{margin: "1% 0% 0% 0%"}}>                
                <Col xs={3} style={{textAlign: "right"}}>
                    <img src={ImageDotright} alt="MessageBox" className="img-fluid" style={{width: "3vmin"}}></img>                   
                </Col>
                <Col style={{textAlign: "Left"}}>
                    <div style={MyStyle2}>                       
                       Verfügbar für iOS, Android, Windows, macOS, Linux und im Webbrowser
                    </div>                                                                                               
                </Col>                
            </Row>
            <br/>
             <Row style={{margin: "1% 0% 0% 0%"}}>                
                <Col xs={5} style={{textAlign: "right"}}>
                    
                </Col>
                <Col style={{textAlign: "Left"}}>
                    <div style={MyStyle2}>                       
                       Sie können die App hier herunterladen
                    </div>                                                                                               
                </Col>                
            </Row>
            <Row style={{margin: "1% 0% 0% 0%"}}>                
                <Col style={{textAlign: "right", padding: "0% 3% 0% 0%"}}>
                    <div style={MyStyle2}>
                        Android
                    </div>
                </Col>
                <Col style={{textAlign: "Left", padding: "0% 0% 0% 3%"}}>
                    <div style={MyStyle2}>
                        iOS
                    </div>
                </Col>                
            </Row>
             <Row style={{margin: "0% 0% 0% 0%"}}>                
                <Col style={{textAlign: "right", padding: "0% 3% 0% 0%"}}>
                    <div style={MyStyle2}>
                        <img src={ImageTelegramGoogle} alt="MessageBox" className="img-fluid" style={{width: "100px"}}></img>                   
                    </div>
                    <br/>            
                    <br/>            
                </Col>
                <Col style={{textAlign: "left", padding: "0% 0% 0% 3%"}}>
                    <div style={MyStyle2}>
                        <img src={ImageTelegramApple} alt="MessageBox" className="img-fluid" style={{width: "100px"}}></img>                   
                    </div>                    
                    <br/>            
                    <br/>            
                </Col>    
                
            </Row>
        </Container>
    )
}

export default Telegram;